// Legacy blog colors - Use design tokens from tailwind.config.js instead
// These will be removed once migration is complete
const highlight = '#d0d0d0'; // Use text-heading

export const Colors = {
  paragraph: '#C0C2C5', // Use text-body
  h1: highlight, // Use text-heading
  h2: highlight, // Use text-heading
  h3: highlight, // Use text-heading
  h4: highlight, // Use text-heading
  strong: highlight, // Use text-heading
  code: highlight, // Use text-code
  inlineCode: highlight, // Use text-code
  blockquote: '#191A20', // Use bg-surface-elevated
  ul: highlight, // Use text-heading
  highlight: highlight, // Use text-heading
};
